import { useEffect, useState } from "react";
import i18n from "../../i18n/index";
import "./LanguageSwitch.css"; // importa o css externo

export default function LanguageSwitch() {
   const [lng, setLng] = useState(i18n.language?.startsWith("pt") ? "pt" : "en");

  useEffect(() => {
    const onChange = (l) => setLng(l?.startsWith("pt") ? "pt" : "en");
    i18n.on("languageChanged", onChange);
    return () => i18n.off("languageChanged", onChange);
  }, []);

  const toggle = () => {
    const next = lng === "en" ? "pt" : "en";
    i18n.changeLanguage(next);
  };

  return (
    <div className="lang-switch">
      <input
        type="checkbox"
        id="lang-toggle"
        className="lang-switch-checkbox"
        checked={lng === "pt"}
        onChange={toggle}
      />
      <label className="lang-switch-label" htmlFor="lang-toggle">
        <span className="lang-switch-flags">
          <img src="/flags/gb.svg" alt="English" className="flag-img" />
          <img src="/flags/br.svg" alt="Português" className="flag-img" />
        </span>
        <span className="lang-switch-ball" />
      </label>
    </div>
  );
}
